"use strict";

angular.module("customer")
.service("PromotionFilterService", function(
    $resource, $rootScope, $state, $q, FlashBag, gettextCatalog, UserService, appConfig
) {
    this.togglePromotionFilter = function() {
        FlashBag.clearAll();
        if ($rootScope.promotionMode || ($rootScope.CurrentNumbers && $rootScope.CurrentNumbers.promotion_product_count > 0)) {
            this.updateMode();
        }
        else {
            FlashBag.preformattedWarning(gettextCatalog.getString("You have no promotions."), "");
        }
    };

    this.updateMode = function() {
        var promotionModeResource = $resource(appConfig.API_SERVER + "/auth/customer/:id/mode/", {id: "@id"}, {
            update: {
                method: "PATCH",
                ignoreLoadingBar: true
            }
        });

        UserService.isUserFetched().then(function onSuccess(user) {
            if (!user.customer) {
                return
            }

            promotionModeResource.get({id: user.customer.id}, function(buyer) {
                buyer.promotion_enabled = !buyer.promotion_enabled;
                buyer.$update().then(function(data) {
                    var promise;
                    if ($state.current.name !== "stocks") {
                        promise = $state.go("stocks");
                    } else {
                        promise = $state.reload();
                    }
                    promise.then(function() {
                        $rootScope.promotionMode = data.promotion_enabled;
                    });
                });
            });
        });
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/app-core/promotion-filter/promotion-filter.service.js
// module id = 812
// module chunks = 0